import React from "react";
import { THEME_COLORS } from "../../../../../color";

const Card = ({ label = "label", value = "value" }) => {
  return (
    <div className="flex flex-1 min-w-[200px] items-center gap-3 rounded-md bg-[#E5F3F6] border border-[#30B79259] p-2 shadow-sm">
      <div className="border border-[#0087A3] rounded-md p-1 shadow-md bg-white">
        <img
          src="/sdg/sdg_group.svg"
          alt="sdg group icon"
          className="w-8 h-8"
        />
      </div>
      <div className="flex flex-col">
        <div
          className="text-sm font-semibold"
          style={{ color: THEME_COLORS.green }}
        >
          {label}
        </div>
        <div
          className="text-lg font-bold"
          style={{ color: THEME_COLORS.green }}
        >
          {value}
        </div>
      </div>
    </div>
  );
};

export default Card;
